<app-login *transloco="let t"
           [formGroup]="loginFormGroup"
           (clickSubmit)="onSubmit()">
  <app-epson-logo [animate]="loading" image></app-epson-logo>
  <app-label message
             isError
             *ngIf="loginErrorMsg"
             id="login-error-message">
    {{t(loginErrorMsg!, { time: blockedLoginSecondsLeft, unit: 's'})}}
  </app-label>
  <app-input firstInput
             id="login-page-email-input"
             type="email"
             [control]="getControl('email')"
             label="{{t('email-address')}}:"></app-input>
  <app-input secondInput
             id="login-page-password-input"
             type="password"
             label="{{t('password')}}:"
             [control]="getControl('password')"></app-input>
  <app-anchor id="login-page-forgot-password-click"
              secondInputSubscript
              [routerLink]="'/'+RoutesKeys.FORGOT_PASSWORD"
              thin>
    {{t('forgot-your-password')}}
  </app-anchor>
  <app-recaptcha
    *ngIf="recaptchaEnabled"
    id="recaptcha-login-invited"
    [formGroup]="loginFormGroup"
    abstractFormControlName="recaptcha"
    recaptcha
    #captchaRef>
  </app-recaptcha>
  <div buttonSection>
    <app-primary-button id="login-page-login-click"
                        type="submit"
                        [disabled]="disableLogin"
                        [abstractControl]="loginFormGroup">
      {{t('login')}}
    </app-primary-button>
    <app-label class="footer">
      {{t('dont-have-epson-rewards-account')}}
      <app-anchor id="login-page-signup-click"
                  [routerLink]="'/'+RoutesKeys.REGISTER">
        {{t('sign-up')}}
      </app-anchor>
    </app-label>
  </div>
  <app-epson-powered bottom></app-epson-powered>
</app-login>
